module.exports = __webpack_public_path__ + "static/media/ball_2_4.e4fbc77f.mp3";